module.exports = __webpack_public_path__ + "static/img/news4-cover.8c2ed88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news4-cover.jpg
// module id = aql+
// module chunks = 0